import { NestedSelectorController } from './nested-selector.controller';
import { NestedSelectorProps } from './nested-selector.model';

export const NestedSelector = (props: NestedSelectorProps) => {
  return <NestedSelectorController {...props} />;
};
